import { parseUrl, toPath } from './url';
import { EventEmitter } from '../event-emitter';

export interface RouterEvent {
  next: string;
  prev?: string;
  url?: URL;
  permit?: boolean;
}

export class Router extends EventEmitter {
  path: string;
  private hasHistoryApi = window.history && window.history.pushState;

  constructor() {
    super();
    window.addEventListener('popstate', this.popState.bind(this));
    window.addEventListener('hashchange', this.hashChange.bind(this));
  }

  navigateTo(path: string, replace = false): void {
    const url = parseUrl(path);
    path = url.pathname;

    if (path === this.path) {
      return;
    }

    const beforeEvent: RouterEvent = {
      prev: this.path,
      next: path,
      permit: true,
    };
    const data = this.emit('beforechange', beforeEvent);
    if (!data.permit) {
      return;
    }
    const prev = this.path;
    this.path = data.next;

    const oldParams = new URLSearchParams(window.location.search);
    // re-apply URL search params
    oldParams.forEach((value, key) => {
      /* istanbul ignore next */
      url.searchParams.set(key, value);
    });

    const changeEvent: RouterEvent = {
      prev,
      next: this.path,
      url,
    };
    this.updateHistory(url.toString(), replace);
    this.emit('change', changeEvent);
  }

  private popState() {
    this.navigateTo(toPath(window.location.href), true);
  }

  private hashChange(event: any) {
    this.navigateTo(toPath(event.newURL));
  }

  private updateHistory(url: string, replace = false) {
    if (!this.hasHistoryApi) {
      /* istanbul ignore next */
      window.location.href = url;
    } else if (replace) {
      window.history.replaceState({}, '', url);
    } else {
      window.history.pushState({}, '', url);
    }
  }
}

export const router = new Router();
